import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import highlight from './highlight.js';

const {
  shape,
  string,
  bool,
  oneOf,
  func
} = PropTypes;
const fixedHeightContainer = {
  overflow: "hidden",
  height: "7.4rem"
};
const fixedHeightHeading = {
  maxHeight: "2.875rem",
  overflow: "hidden",
  lineHeight: "1.3"
};
const fixedHeightParagraph = {
  maxHeight: "4.125rem",
  textOverflow: "ellipsis"
};
const updatedAtStyles = {
  fontStyle: "italic",
  fontSize: "0.775rem"
};
const validHeaderPriorities = [1, 2, 3, 4, 5, 6];
function ContentInformation({
  className,
  content,
  fixedHeight,
  noLink,
  trackEvent,
  onTitleClick
}) {
  const headingClassNames = cx({
    "tds-text-size_6": !noLink
  }, {
    "tds-color_black": noLink
  }, {
    "slds-text-heading_large": noLink && content.type !== "customstep"
  }, {
    "tds-text-size_6": noLink && content.type === "customstep"
  });
  const handleClick = () => {
    onTitleClick();
    trackEvent("Clicked", {
      ...content
    });
  };
  const notBlank = value => !(value == null || value === "" || value === undefined);
  const hasAuthorPath = trailmix => notBlank(trailmix) && notBlank(trailmix.author) && notBlank(trailmix.author.path);
  const renderSubTitle = () => {
    if (content && content.trailmix) {
      if (hasAuthorPath(content.trailmix)) return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, content.subTitle), " ", /*#__PURE__*/React.createElement("a", {
        href: content.trailmix.author.path
      }, content.trailmix.author.name));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, content.subTitle), " ", content.trailmix.author.name);
    }
    return /*#__PURE__*/React.createElement("div", null, content.subTitle);
  };
  const linkAttributes = () => {
    if (content.type === "customstep") {
      return {
        target: "_blank",
        rel: "noopener noreferrer"
      };
    }
    return {};
  };
  const renderTitle = () => {
    if (content.titleHighlights) {
      return /*#__PURE__*/React.createElement("a", Object.assign({
        href: content.path,
        onClick: handleClick
      }, linkAttributes(), {
        dangerouslySetInnerHTML: {
          __html: highlight(content.title, content.titleHighlights)
        }
      }));
    }
    return /*#__PURE__*/React.createElement("a", Object.assign({
      href: content.path,
      onClick: handleClick
    }, linkAttributes()), content.title);
  };
  const renderDescription = () => {
    if (content.descriptionHighlights) {
      return /*#__PURE__*/React.createElement("p", {
        style: fixedHeight ? fixedHeightParagraph : {},
        dangerouslySetInnerHTML: {
          __html: highlight(content.description, content.descriptionHighlights)
        }
      });
    }
    return /*#__PURE__*/React.createElement("p", {
      style: fixedHeight ? fixedHeightParagraph : {}
    }, content.description);
  };
  const renderLastUpdatedOn = () => {
    if (content.lastUpdatedOn) {
      return /*#__PURE__*/React.createElement("p", {
        style: updatedAtStyles
      }, content.lastUpdatedOn);
    }
    return null;
  };
  const defaultTitleHeaderTag = noLink ? `h1` : `h2`;
  const isValidPriority = validHeaderPriorities.includes(content.titleHeaderPriority);
  const TitleHeaderTag = isValidPriority ? `h${content.titleHeaderPriority}` : defaultTitleHeaderTag;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: fixedHeight ? fixedHeightContainer : {}
  }, renderSubTitle(), noLink && /*#__PURE__*/React.createElement(TitleHeaderTag, {
    className: cx(headingClassNames, "slds-hyphenate tds-text_bold slds-m-bottom_xx-small"),
    style: fixedHeight ? fixedHeightHeading : {}
  }, content.title), !noLink && /*#__PURE__*/React.createElement(TitleHeaderTag, {
    className: cx(headingClassNames, "slds-hyphenate tds-text_bold slds-m-bottom_xx-small"),
    style: fixedHeight ? fixedHeightHeading : {},
    "data-test": "content-title"
  }, renderTitle()), renderDescription(), renderLastUpdatedOn());
}
ContentInformation.displayName = "ContentInformation";
ContentInformation.defaultProps = {
  className: null,
  content: null,
  fixedHeight: false,
  noLink: false,
  trackEvent: () => {},
  onTitleClick: () => {}
};
ContentInformation.propTypes = {
  className: string,
  content: shape({
    title: string.isRequired,
    titleHeaderPriority: oneOf(validHeaderPriorities),
    subTitle: string.isRequired,
    path: string,
    description: string.isRequired,
    trailmix: shape({
      author: shape({
        name: string.isRequired,
        path: string.isRequired
      }).isRequired
    }),
    type: oneOf(["trail", "module", "project", "trailmix", "customstep", "superbadge", "credential"]).isRequired
  }),
  fixedHeight: bool,
  noLink: bool,
  trackEvent: func,
  onTitleClick: func
};

export { ContentInformation as default };
